'use strict';

module.exports = '3.1.1';